<template>
  <el-dialog
    title="Сгенерировать отчет"
    :visible.sync="visible"
    :append-to-body="true"
    :width="isMobile ? '95%' : '600px'"
    :before-close="closeDialog"
  >
    <generate-report-form @close="closeDialog" @sendForm="sendForm" />
  </el-dialog>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'

import GenerateReportForm from '@/views/Home/Shipping/Modals/GenerateReport/Form'

const totalReportAPI = RepositoryFactory.get('totalReport')

export default {
  name: 'GenerateReport',
  components: {
    GenerateReportForm,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    closeDialog() {
      this.$emit('close')
    },
    async sendForm(value) {
      await totalReportAPI
        .post(value, this.item)
        .then(response => {
          if (response.data.errors.length) {
            response.data.errors.map(error => {
              setTimeout(() => this.$message.error(error), 500)
            })
          }
          if (response.data.model !== undefined) {
            this.$message({
              message: 'Отчет сформирован',
              type: 'success',
            })
          }
        })
        .catch(e => this.$message.error(e))
    },
  },
}
</script>

<style scoped></style>
